module.exports = __webpack_public_path__ + "img/11.a5060aaf.jpg";